import React from "react";
import styled from "styled-components";
import Skeleton from "../Skeleton/Skeleton";
import { SkeletonShapeEnum } from "../Skeleton/SkeletonEnums";
import { ThemeIconSizeEnum } from "../Themes/ThemeEnums";
import AppTileGrid from "./AppTileGrid";

const Tile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 8px;
  aspect-ratio: 1;
`;

interface AppTileGridSkeletonProps {
  count?: number;
  columns?: number;
}

const AppTileGridSkeleton: React.FC<AppTileGridSkeletonProps> = ({ count = 6, columns }) => (
  <AppTileGrid columns={columns}>
    {Array.from({ length: count }, (_, index) => (
      <Tile key={index} aria-hidden="true">
        <Skeleton shape={SkeletonShapeEnum.CIRCLE} width={ThemeIconSizeEnum.EXTRA_LARGE} />
        <Skeleton shape={SkeletonShapeEnum.TEXT} width="60%" />
      </Tile>
    ))}
  </AppTileGrid>
);

export default AppTileGridSkeleton;
